<ng-template #input>
	<div class="input-wrapper">
		<input type="text"
			   class="form-control"
			   [class.phrases-active]="templateFieldId"
			   [id]="id"
			   [formControl]="control | formControlSanitizer: securityContext.HTML | formControlSanitizer: securityContext.SCRIPT"
			   [placeholder]="'― ' + placeholder"
			   [spellcheck]="spellcheck">

		<div class="indicators-wrapper">
			<div *ngIf="(control.touched || control.dirty) && control.errors" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-xmark"></i>
				</span>
			</div>

			<div *ngIf="control.valid && (!control.pristine || control.value)" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-check"></i>
				</span>
			</div>

			<div *ngIf="control.pristine && !control.disabled && isControlRequired && !control.touched && !control.value && !(warnings && warnings.deprecated)"
				 class="icon-indicator color-primary separator">
				<span class="inner-wrapper">
					<shared-icon-sprite svgId="asterisk" height="14px" width="12px" class="mb-1"></shared-icon-sprite>
				</span>
			</div>

			<div *ngIf="warnings && warnings.deprecated" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fal fa-exclamation-triangle"></i>
				</span>
			</div>

			<div *ngIf="control.disabled" class="icon-indicator separator">
				<span class="inner-wrapper">
					<shared-icon-sprite svgId="lock" height="22px" width="18px" class="mb-2"></shared-icon-sprite>
				</span>
			</div>

			<div class="icon-indicator action-btn separator"
				 *ngIf="templateFieldId">
				<span class="inner-wrapper phrases">
					<form-phrases-select
						[templateFieldId]="templateFieldId"
						(phraseSelected)="phraseSelect($event)"></form-phrases-select>
				</span>
			</div>

			<div *ngIf="search && (control.pristine || !control.value) && !(warnings && warnings.deprecated)"
				 class="icon-indicator separator">
				<span class="inner-wrapper search-icon">
					<shared-icon-sprite svgId="search" height="20px" width="20px" class="mb-1"></shared-icon-sprite>
				</span>
			</div>
		</div>

	</div>
</ng-template>

<ng-template #vertical>
	<div class="input-group input-vertical">
		<div class="input-container col-12 p-0"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="control.valid && control.value">
			<label [class.d-none]="!label" *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						  [ngbTooltip]="t('warnings.'+warning.key)"
						  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #horizontal>
	<div class="input-group input-horizontal">
		<div class="input-container"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="control.valid && control.value">
			<label [class.d-none]="!label" *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						[ngbTooltip]="t('warnings.'+warning.key)"
						container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #inputLeft>
	<div class="input-group input-left">
		<div class="input-container"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
	 		 [class.input-container-valid]="control.valid && control.value">
			<label [class.d-none]="!label" *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						[ngbTooltip]="t('warnings.'+warning.key)"
						container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #inputRight>
	<div class="input-group input-right">
		<div class="input-container"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="control.valid && control.value">
			<label [class.d-none]="!label" *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						[ngbTooltip]="t('warnings.'+warning.key)"
						container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #inline>
	<div class="input-group input-inline">
		<div class="input-container"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="control.valid && control.value">
			<label [class.d-none]="!label" *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						[ngbTooltip]="t('warnings.'+warning.key)"
						container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #errors>
	<ng-container *ngIf="(control.touched)">
		<div class="control-errors-wrapper">
			<div class="control-errors col-12"
				 [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
				 *ngFor="let error of control.errors | keyvalue">
				<span class="error" *transloco="let t">{{ t('generic.'+error.key) }}</span>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-container>
	<div [ngSwitch]="template" class="form-control-container">
		<ng-container *ngSwitchCase="ControlTemplate.horizontal">
			<ng-container *ngTemplateOutlet="horizontal"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.vertical">
			<ng-container *ngTemplateOutlet="vertical"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inputLeft">
			<ng-container *ngTemplateOutlet="inputLeft"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inputRight">
			<ng-container *ngTemplateOutlet="inputRight"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inline">
			<ng-container *ngTemplateOutlet="inline"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
	</div>
</ng-container>
